module.exports = __webpack_public_path__ + "img/logo.593899df.png";